module.exports = {
  text: `Все мы слышали о дварфах, которые влюблялись в свои творения, поиски сокровищ или в эль, настолько, что забывали, что в жизни есть что–либо ещё кроме их вожделенной цели. Таковы каменные великаны.`,
  author: `Эльминстер`,
}
